/**
 * CAUSA RAIZ (confirmada via aba Network do DevTools):
 *
 * O Klaviyo carrega um único <script> "loader" na página
 * (klaviyo.js?company_id=...), que depois vai buscar dinamicamente,
 * via chunks internos (webpack), tudo o resto: reviews, formulários,
 * back-in-stock, etc. Não existe uma tag <script> isolada e
 * previsível só para "reviews" que se possa intercetar diretamente —
 * o scan aos `.klaviyo-star-rating-widget` acontece algures dentro
 * dessa cadeia de chunks, disparado pelo próprio loader.
 *
 * O custom element <related-products> (definido em related-products.js)
 * carrega o conteúdo dos cartões via fetch() ASSÍNCRONO e injeta-o com
 * innerHTML depois da resposta chegar — por definição, isto só pode
 * terminar depois do carregamento inicial da página. Quando o Klaviyo
 * arranca (e faz o seu scan) antes desse fetch terminar, os widgets
 * desse bloco ficam vazios.
 *
 * FIX: interceta o <script> loader do Klaviyo (klaviyo.js?company_id=...)
 * antes de correr (neutralizando-o com type="text/plain") e só o
 * liberta depois de confirmar que todos os blocos assíncronos
 * relevantes já têm conteúdo. Isto atrasa o arranque de TODO o
 * Klaviyo (não só reviews) até o carrossel estar pronto — um atraso
 * de, tipicamente, algumas centenas de ms, impercetível para quem
 * visita a loja. Timeout de segurança para páginas sem estes blocos,
 * ou caso algo corra mal.
 */
(function () {
  var RELATED_SELECTOR = '[data-related-section]';
  var RECENTLY_VIEWED_SELECTOR = '[data-recently-viewed-wrapper]';
  var NATIVE_RECOMMENDATIONS_SELECTOR = 'product-recommendations';
  var SAFETY_TIMEOUT_MS = 4000;
  var POLL_INTERVAL_MS = 100;

  var klaviyoScriptTag = null;
  var released = false;

  function hasRenderedContent(el) {
    if (!el) return true; // bloco não existe nesta página, não bloqueia
    return el.children.length > 0 || el.querySelector('[data-grid-item], .product-item') !== null;
  }

  function nativeRecommendationsReady() {
    var el = document.querySelector(NATIVE_RECOMMENDATIONS_SELECTOR);
    if (!el) return true;
    return el.classList.contains('product-recommendations--loaded') || hasRenderedContent(el);
  }

  function allBlocksReady() {
    var related = document.querySelector(RELATED_SELECTOR);
    var recent = document.querySelector(RECENTLY_VIEWED_SELECTOR);
    return hasRenderedContent(related) && hasRenderedContent(recent) && nativeRecommendationsReady();
  }

  function releaseKlaviyoScript() {
    if (released || !klaviyoScriptTag) return;
    released = true;

    var realScript = document.createElement('script');
    for (var i = 0; i < klaviyoScriptTag.attributes.length; i++) {
      var attr = klaviyoScriptTag.attributes[i];
      if (attr.name !== 'type') {
        realScript.setAttribute(attr.name, attr.value);
      }
    }
    if (klaviyoScriptTag.src) {
      realScript.src = klaviyoScriptTag.src;
    } else {
      realScript.text = klaviyoScriptTag.text;
    }
    klaviyoScriptTag.parentNode.replaceChild(realScript, klaviyoScriptTag);
  }

  function pollUntilReady() {
    var start = Date.now();

    (function poll() {
      if (allBlocksReady() || Date.now() - start > SAFETY_TIMEOUT_MS) {
        releaseKlaviyoScript();
        return;
      }
      setTimeout(poll, POLL_INTERVAL_MS);
    })();
  }

  // Interceta o script do Klaviyo assim que for injetado no <head>,
  // antes de o browser chegar a executá-lo.
  var headObserver = new MutationObserver(function (mutations) {
    for (var m = 0; m < mutations.length; m++) {
      var addedNodes = mutations[m].addedNodes;
      for (var n = 0; n < addedNodes.length; n++) {
        var node = addedNodes[n];
        if (
          node.tagName === 'SCRIPT' &&
          node.src &&
          node.src.indexOf('klaviyo.js') !== -1 &&
          node.src.indexOf('company_id=') !== -1
        ) {
          klaviyoScriptTag = node;
          node.setAttribute('type', 'text/plain'); // neutraliza, browser não executa
          headObserver.disconnect();
          pollUntilReady();
          return;
        }
      }
    }
  });

  headObserver.observe(document.documentElement, { childList: true, subtree: true });
})();